
import { defineComponent, ref, onMounted, reactive } from "vue";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import SearchAndFilter from "@/views/still/search_and_filters.vue";
import mAxiosApi from "@/api";
import { ElNotification } from 'element-plus'

export default defineComponent({
  name: "TenantsList",
  components: {
    Datatable,
    SearchAndFilter,
  },

  emits: ["displayTenant"],

  setup(props, { emit }) {
    const state = reactive({
      loaderEnabled: true,
      myList: [] as any,
      initialMyList: [],
      loadingDatatable: 0,
    });

    const tableHeader = ref([
      { name: "Code Ark", key: "code_ark", sortable: true },
      { name: "Nom", key: "name", sortable: true },
      { name: "Serveur DB", key: "db_address", sortable: false },
      { name: "Base de données", key: "db_database", sortable: false },
      { name: "OIDC Org ID", key: "oidc_org_id", sortable: false },
      { name: "Statut", key: "active", sortable: true },
      { name: "", key: "actions", sortable: false },
    ]);

    const tableFilters = ref([
      { name: "Statut", key: "active_label", label: "active_label" },
    ]);

    onMounted(async () => {
      try {
        const response = await mAxiosApi.get("/getTenants");
        const results = response.data.results || [];
        results.forEach((t: any) => {
          t.active_label = t.active == 1 ? "Actif" : "Inactif";
        });
        state.myList = results;
        state.initialMyList = results;
      } catch {
        state.myList = [];
        state.initialMyList = [];
      }
      state.loaderEnabled = false;
    });

    const displayTenant = (d: any) => {
      emit("displayTenant", d);
    };

    const onDeactivate = async (codeArk: string) => {
      try {
        await mAxiosApi.post("/deleteTenant", { code_ark: codeArk });
        ElNotification({ title: 'Succès', message: 'Tenant désactivé avec succès !', type: 'success' });
        const response = await mAxiosApi.get("/getTenants");
        const results = response.data.results || [];
        results.forEach((t: any) => {
          t.active_label = t.active == 1 ? "Actif" : "Inactif";
        });
        state.myList = results;
        state.initialMyList = results;
      } catch {
        ElNotification({ title: 'Erreur', message: 'Erreur lors de la désactivation du tenant.', type: 'error' });
      }
    };

    return {
      state,
      tableHeader,
      tableFilters,
      displayTenant,
      onDeactivate,
    };
  },
});
